module.exports = __webpack_public_path__ + "df6ba0210fcf6bdc7c1ebcf8533214a1.png";